import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type LocationModel from 'garaje/models/location';
import type WorkplaceDayModel from 'garaje/models/workplace-day';
import DesksReservationsRoute from 'garaje/pods/desks/reservations/route';

export interface DesksReservationsRouteModel {
  currentLocation: LocationModel;
  workplaceDays: WorkplaceDayModel[];
}

export default class ResourcesReservationsRoute extends DesksReservationsRoute {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  beforeModel(): void {
    if (this.abilities.cannot('visit resources')) {
      return void this.router.transitionTo('unauthorized');
    }
  }
}
